import { useEffect, useMemo, useState } from 'react'

interface UseLoadingProps {
  duration?: number
  onComplete: () => void
}

const SHORTEN_LOADING_ON_DEV = false

export function useLoading({ duration = 5000, onComplete }: UseLoadingProps) {
  const [percentage, setPercentage] = useState(0)
  const currentDuration = useMemo(() => __DEV__ && SHORTEN_LOADING_ON_DEV ? duration * 0.2 : duration, [duration])

  const roundedPercentage = useMemo(() => Math.round(percentage), [percentage])

  useEffect(() => {
    const timer = setInterval(() => {
      setPercentage((prevPercentage) => {
        let coefficient = (100 - prevPercentage) / (Math.random() * 100 + 1)

        if (coefficient > 5) {
          coefficient = 5
        }

        const nextPercentage = prevPercentage + coefficient
        return (nextPercentage < 100 ? nextPercentage : 100)
      })
    }, (currentDuration) / 100)

    return () => {
      clearInterval(timer)
    }
  }, [currentDuration])

  useEffect(() => {
    if (roundedPercentage >= 100) {
      onComplete()
    }
  }, [roundedPercentage, onComplete])

  return { percentage, roundedPercentage }
}
